// extracted by mini-css-extract-plugin
module.exports = {"efCollectionH5A":"A_efCollectionH5A__nwLjq"};